import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { getProgramProjectReport } from '../../../../infrastructure/api/program-project-reports'
import { addGlobalMessage, MessageLevel } from '../../../../store/messages'
import {
  ProgramProjectReportRow,
  toProgramProjectReportRows,
} from '../model/reportRow'

type UseProgramProjectReportDataReturn = {
  data: ProgramProjectReportRow[]
  loading: boolean
  fetch: () => Promise<void>
}

export const useProgramProjectReportData =
  (): UseProgramProjectReportDataReturn => {
    const dispatch = useDispatch()
    const intl = useIntl()
    const [data, setData] = useState<ProgramProjectReportRow[]>([])
    const [loading, setLoading] = useState(true)

    const fetch = useCallback(async () => {
      setLoading(true)
      try {
        const dto = await getProgramProjectReport()
        setData(dto ? toProgramProjectReportRows(dto) : [])
      } catch {
        dispatch(
          addGlobalMessage({
            type: MessageLevel.ERROR,
            title: intl.formatMessage({ id: 'global.error.systemError' }),
          })
        )
      } finally {
        setLoading(false)
      }
    }, [dispatch, intl])

    useEffect(() => {
      fetch()
    }, [fetch])

    return { data, loading, fetch }
  }
